/* =========================================================================
   Cart Drawer mit Mobile-Scroll-Lock
   =======================================================================*/

/* -------------------------------------------------
   kleine Helfer, greifen nur auf Mobile-Breite
--------------------------------------------------*/
const mobileMQ = window.matchMedia('(max-width: 990px)');

function freezeBody() {
  if (!mobileMQ.matches) return;                               // nur Mobile
  const y = window.scrollY || document.documentElement.scrollTop;
  document.body.dataset.scrollY = y;                           // Position merken
  document.body.style.position  = 'fixed';                     // einfrieren
  document.body.style.top       = `-${y}px`;
  document.body.style.width     = '100%';
}

function releaseBody() {
  if (!mobileMQ.matches) return;
  const y = parseInt(document.body.dataset.scrollY || '0', 10);
  document.body.style.position  = '';
  document.body.style.top       = '';
  document.body.style.width     = '';
  window.scrollTo(0, y);                                       // Position zurück
  document.body.removeAttribute('data-scrollY');
}

/* -------------------------------------------------
   CartDrawer-Klasse
--------------------------------------------------*/
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    /* Esc-Taste */
    this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());

    /* Overlay-Klick */
    this.querySelector('#CartDrawer-Overlay')
        .addEventListener('click', this.close.bind(this));

    /* Icon in der Header-Leiste zugänglich machen */
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (e) => {
      if (e.code.toUpperCase() === 'SPACE') {
        e.preventDefault();
        this.open(cartLink);
      }
    });
  }

  /* ---------- Drawer auf ---------- */
  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;

    /* Summary-Element fürs A11y präparieren */
    const note = this.querySelector('[id^="Details-"] summary');
    if (note && !note.hasAttribute('role')) this.setSummaryAccessibility(note);

    /* Animation starten (Timeout behebt Timing-Bug) */
    setTimeout(() => this.classList.add('animate', 'active'));

    /* Fokus einschließen, sobald Animation fertig */
    this.addEventListener('transitionend', () => {
      const container = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const startFocus = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(container, startFocus);
    }, { once: true });

    /* Seite blockieren */
    document.body.classList.add('overflow-hidden');    // Dawn-Standard
    freezeBody();                                      // nur Mobile
  }

  /* ---------- Drawer zu ---------- */
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    document.body.classList.remove('overflow-hidden');
    releaseBody();                                     // nur Mobile
  }

  /* ---------- A11y für “Anmerkungen” ---------- */
  setSummaryAccessibility(summary) {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');

    if (summary.nextElementSibling.id) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (e) => {
      const isOpen = !e.currentTarget.closest('details').hasAttribute('open');
      e.currentTarget.setAttribute('aria-expanded', isOpen);
    });

    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  /* ---------- Inhalte nach Ajax-Update rendern ---------- */
  renderContents(parsed) {
    const inner = this.querySelector('.drawer__inner');
    inner.classList.contains('is-empty') && inner.classList.remove('is-empty');

    this.productId = parsed.id;

    /* Abschnitte ersetzen */
    this.getSectionsToRender().forEach((s) => {
      const el = s.selector ? document.querySelector(s.selector)
                            : document.getElementById(s.id);
      if (!el) return;
      el.innerHTML = this.getSectionInnerHTML(parsed.sections[s.id], s.selector);
    });

    /* Drawer nachrüsten und erneut öffnen */
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')
          .addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  /* ---------- Helfer ---------- */
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html')
                          .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer',      selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }
}

customElements.define('cart-drawer', CartDrawer);

/* -------------------------------------------------
   CartDrawerItems  (unverändert)
--------------------------------------------------*/
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer',       section: 'cart-drawer',      selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
